import { useGlobalContext } from "../context";
import { useNavigate } from "react-router";
import MoviesPlaceholder from "../components/MoviesPlaceholder";

/* Footer style */
const footerStyle = {
  paddingTop: "1rem",
  fontSize: "1rem",
  color: "rgb(158, 187, 187)",
  backgroundColor: "#1a2538",
  left: 0,
  bottom: 0,
  width: "100%",
};

/* Home component */
function Home() {
  const navigate = useNavigate();
  const { movies, setSearch } = useGlobalContext();

  /**
   * @desc Get movie details
   * @param {*} movieId
   */
  const showMovieDetails = (movieId) => {
    navigate(
      `/movie/${movieId}`,
      {
        state: {},
      },
      { replace: true }
    );
  };

  /**
   * @desc Search a movie
   */
  const searchMovie = async (movie) => {
    setSearch(movie);
  };

  return (
    <>
      {/* <MoviesPlaceholder /> */}
      <div
        style={{
          marginTop: "5.5rem",
          color: "#cae7fc",
          marginLeft: "2rem",
          marginRight: "2rem",
          background:
            "linear-gradient(90deg, rgba(235,42,42,1) 100%, rgba(244,217,217,1) 100%)",
        }}
        className="jumbotron p-5 rounded"
        id="goto-top"
      >
        <h1 className="display-4">
          Welcome to{" "}
          <b style={{ color: "#fff", fontWeight: "600" }}>BookMySeats</b>!
        </h1>
        <p className="lead">Search and book movie shows online.</p>
        <hr style={{ color: "white" }} />
        <input
          className="form-control"
          placeholder="Search a movie..."
          style={{
            textAlign: "center",
            wordSpacing: "0.2rem",
            letterSpacing: "0.2rem",
          }}
          onChange={(e) => searchMovie(e.target.value)}
        />
      </div>
      <div style={{ marginTop: "1rem" }} className="m-5">
        <div>
          {movies.length !== 0 ? (
            <div className="d-flex flex-wrap justify-content-around">
              {movies.map((movie) => {
                return (
                  <div
                    className="card mb-3"
                    key={movie._id}
                    style={{
                      width: "20rem",
                      height: "33rem",
                      cursor: "pointer",
                      boxShadow: "0px 10px 33px -7px rgba(0,0,0,0.75)"
                    }}
                    onClick={() => showMovieDetails(movie._id)}
                  >
                    <div className="card-body">
                      <img
                        className="w-100 h-100 img-fluid"
                        src={movie.image}
                        alt={movie.name}
                      />
                    </div>
                    <div
                      className="card-header"
                      style={{
                        backgroundColor: "#a3c1d4",
                      }}
                    >
                      <b>{movie.name}</b>{" "}
                      <span className="text-muted">({movie.genre})</span>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <MoviesPlaceholder />
          )}
        </div>
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          width: "100%",
          color: "azure",
          backgroundColor: "#333",
          height: "3rem",
        }}
      >
        <a
          href="#goto-top"
          alt="Back to top"
          style={{ textDecoration: "none", color: "azure" }}
        >
          Back to top
        </a>
      </div>
      <div style={footerStyle}>
        <div className="container">
          <div className="d-flex justify-content-center flex-wrap p-3">
            <div>
              <p style={{ textAlign: "center" }}>
                <big>
                  <b>
                    <u>Contact</u>
                  </b>
                </big>
              </p>
              <ol
                style={{
                  textAlign: "center",
                  listStyle: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                <li>
                  <span>
                    <b>Helpline</b>
                  </span>
                  : +91-1231231230
                </li>
                <li>
                  <span>
                    <b>Instagram ID</b>
                  </span>
                  : bookmywseats-please
                </li>
                <li>
                  <span>
                    <b>Email</b>
                  </span>
                  : bookmyseats@gmail.com
                </li>
              </ol>
            </div>
          </div>
          <hr />
          <p
            style={{
              fontSize: "1.5rem",
              textAlign: "center",
              paddingBottom: "2rem",
              color: "white",
            }}
          >
            BookMySeats ©
          </p>
        </div>
      </div>
    </>
  );
}

export default Home;
